﻿/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { BalanceComponent } from './balance/balance.component';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/index';
import { HomeComponent } from './home/index';
import { ArancelesComponent } from './aranceles/aranceles.component';
import { BibliotecaComponent } from './biblioteca/biblioteca.component';
import { FormulariosComponent } from './formularios/formularios.component';
import { ResolucionesComponent } from './resoluciones/resoluciones.component';
import { DatosComponent } from './datos/datos.component';
import { AuthGuard } from './_guards/index';
import { CertificadoComponent } from './certificado/certificado.component';
import { CertificadoDistribuidoraComponent } from './distribuidora/certificado/certificado.component';
import { HomeDistribuidoraComponent } from './distribuidora/home/home.component';
import { MatriculadoGuard } from './_guards/matriculado.guard';
import { DistribuidoraGuard } from './_guards/distribuidora.guard';
import { ComunicacionComponent } from './comunicacion/comunicacion.component';
import { ComunicacionGuard } from './_guards/comunicacion.guard';
import { TribunalComponent } from './tribunal/tribunal.component';
import { VideoplayerComponent } from './videoplayer/videoplayer.component';
import { DocumentosComponent } from './documentos/documentos.component';

const activate_matriculado = [AuthGuard, MatriculadoGuard, ComunicacionGuard];
const activate_distribuidora = [AuthGuard, DistribuidoraGuard];

const appRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: '', component: DatosComponent, canActivate: activate_matriculado },
    { path: 'balance_cuenta', component: HomeComponent, canActivate: activate_matriculado },
    { path: 'aranceles', component: ArancelesComponent, canActivate: activate_matriculado },
    { path: 'biblioteca', component: BibliotecaComponent, canActivate: activate_matriculado },
    { path: 'formularios', component: FormulariosComponent, canActivate: activate_matriculado },
    { path: 'resoluciones', component: ResolucionesComponent, canActivate: activate_matriculado },
    { path: 'documentos', component: DocumentosComponent, canActivate: activate_matriculado },
    { path: 'balance', component: BalanceComponent, canActivate: activate_matriculado },
    { path: 'certificado', component: CertificadoComponent, canActivate: activate_matriculado },
    { path: 'comunicacion', component: ComunicacionComponent, canActivate: [AuthGuard, MatriculadoGuard] },
    { path: 'distribuidora/certificado', component: CertificadoDistribuidoraComponent, canActivate: activate_distribuidora },
    { path: 'distribuidora/home', component: HomeDistribuidoraComponent, canActivate: activate_distribuidora },
    { path: 'tribunal', component: TribunalComponent, canActivate: activate_matriculado },
    { path: 'video', component: VideoplayerComponent, canActivate: activate_matriculado },

    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes);
